export const getTabButtonStyles = (isActive, themeGet) => {
  if (isActive) {
    return themeGet('colors.heading.level.2')
  } else if (!isActive) {
    return themeGet('colors.darkGray')
  }
}
